module.exports = __webpack_public_path__ + "img/hy_dzp.83c891cd.svg";